import {
  AdministrativeData,
  CartConfiguration,
  FieldData,
  LooseItemRequest,
} from "../../types";
import api from "../axios";
import { MarketingData } from '../../types/index';

interface AdministrativeDataRequest
  extends Omit<AdministrativeData, "forMilitaryUse"> {
  forMilitaryUse?: boolean;
}

export interface GeneratePurchaseOrderRequest {
  purchaseOrderDetails: {
    administrativeData: AdministrativeDataRequest;
    marketingData: MarketingData;
  },
  configurations: CartConfiguration[];
  looseParts: LooseItemRequest[];
  uiVersion: string;
}

export const postGeneratePurchaseForm = async (
  payload: GeneratePurchaseOrderRequest
) => {
  try {
    const response = await api.post(
      "Orders/PurchaseOrders/generate",
      payload,
      {
        withCredentials: true,
        responseType: "arraybuffer"
      }
    );

    const isRequestOk = response.status >= 200 && response.status < 300;

    return isRequestOk ? response.data : null;
  } catch (error) {
    console.error("Error fetching questions:", error);
    throw error;
  }
};

export const getFieldsData = async () => {
  try {
    const response = await api.get<FieldData>(
      `Selectors/PurchaseOrders/fieldsData`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};
